export default {
  headerContent: {
    title: 'Ray Sigorta İş Yeri Sigortası Hesaplama',
    slogan: "İş Yeri Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'İŞ YERİ SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Ray Sigorta İş Yeri Sigortası',
    description: {
      title: 'Ray Sigorta İş Yeri (Paket) Sigortası Nedir? ',
      content: [
        'İş yeri sigortası, işletmede oluşabilecek risklere karşı güvence sağlamaktadır.',
        'İş yeri sigortası ile işletmenizi yangın, hırsızlık, deprem gibi birçok riske karşı güvence altına alarak büyük çaplı maddi kayıpları önleyebilirsiniz.'
      ]
    },
    subContent: {
      title: 'Ray Sigorta İş Yeri Sigortası Paketleri Nelerdir?',
      content: [
        {
          paragraph: 'Ray Sigorta müşterilerine sektöre göre paket sunmaktadır. Bu paketler;',
          subList: [
            'İş Yeri Güvence Paketi',
            'İşler Rayında KOBİ',
            'Eczane Paket',
            'Otel Paket'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'İş Yeri Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'İş Yeri Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'İş Yeri Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Ray Sigorta İş Yeri Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
